module.exports = __webpack_public_path__ + "media/img/scholarships/default_banner-f0601da20b8cb8230871d3ee2c288d9e.png";